import { waitForMilliseconds } from '@/game/GameComponents/PhaserGame/Utils/PhaserUtils';

export class UIController {
  constructor(
    public scene: Phaser.Scene,
    public element: Phaser.GameObjects.Container,
  ) {
    this.scene = scene;
    this.element = element;

    this.setupChildrenInteractions(element);
  }

  async setupChildrenInteractions(container: Phaser.GameObjects.Container) {
    await waitForMilliseconds(this.scene.time, 10);
    container.list.forEach((item: Phaser.GameObjects.GameObject) => {
      if (item instanceof Phaser.GameObjects.Container) {
        this.setupChildrenInteractions(item);
      } else {
        item.setInteractive({ draggable: true });
        item.on('drag', (e: any) => {
          this.onDrag(this, e);
        });
      }
    });
  }

  public onDrag: (component: UIController, event: any) => void = () => {};
}
